export default __webpack_public_path__ + "static/media/icon-notifications-border-color-gray.80972bce.svg";